import React, { useEffect, useState } from "react"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import toast from "react-hot-toast"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import ReactLoading from "react-loading"
import Modal from "antd/es/modal/Modal"
// api
import {
  getAllBranches,
  getPurchaseOrder,
} from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import { getAllForwarders } from "../../../../Helpers/apiCalls/forwardersApi"
import {
  createItem,
  editItem,
  getItem,
  searchItem,
} from "../../../../Helpers/apiCalls/itemsApi"
import {
  createInvoice,
  deletePiAttachment,
  getInvoice,
  updateInvoice,
} from "../../../../Helpers/apiCalls/Purchases/purchaseInvoiceApi"
import Upload from "antd/es/upload/Upload"

// assets & styles
import {
  getTodayDateISO,
  numberFormat,
  toastStyle,
  TokenExpiry,
  getUser,
  formatDate,
  numberFormatInt,
  antdesignSelectStyle,
} from "../../../../Helpers/Utils/Common"
import trash from "./../../../../Assets/Images/trash.png"
import Navbar from "../../../../Components/Navbar/Navbar"
import "./../../PurchaseOrders/PurchaseOrders.css"
import "./../PurchaseInvoices.css"
import { Fragment } from "react"
import InputError from "../../../../Components/InputError/InputError"
import { validateFormPurchaseInvoice } from "../../../../Helpers/Validation/Purchase/PurchaseInvoiceValidation"
import upload from "../../../../Assets/Images/upload.png"
import {
  getCategory,
  getSubcategory,
} from "../../../../Helpers/apiCalls/categoryApi"
import { getBrand } from "../../../../Helpers/apiCalls/brandsApi"
import AddModal from "../../../../Components/Modals/AddModal"
import { validateItems } from "../../../../Helpers/Validation/Manage/ItemsValidation"
import { Typeahead } from "react-bootstrap-typeahead"
import equal from "../../../../Assets/Images/equal.png"
import FileExceedModal from "../../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import { createItemPrice } from "../../../../Helpers/apiCalls/Manage/ItemPrice"
import { getAllPriceLevels } from "../../../../Helpers/apiCalls/Manage/PriceLevels"
import Footer from "../../../../Components/Footer/Footer"

/**
 *  -- COMPONENT: FORM TO ADD OR EDIT PURCHASE INVOICE
 */
function FormPurchaseInvoice({ add, edit }) {
  const { Dragger } = Upload
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  const [isChanged, setIsChanged] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  /**
   *  @po_id - param for add purchase invoice form
   *  @pi_id - param for edit purchase invoice form
   */
  const { po_id, pi_id } = useParams()

  // PURCHASE INVOICE DETAILS HANDLER
  const [addPI, setAddPI] = useState({})
  const [itemList, setItemList] = useState([])
  const [additionalItemList, setAdditionalItemList] = useState([])
  const [file, setFile] = useState("")
  const [fileList, setFileList] = useState([])
  const [items, setItems] = useState([])
  const [itemsOptions, setItemsOptions] = useState([])
  const [units, setUnits] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  const [branchList, setBranchList] = useState([])
  const [priceLevelDetails, setPriceLevelDetails] = useState([[]])
  const [priceLevel, setPriceLevels] = useState([])
  const [filteredPriceLevel, setFilteredPriceLevels] = useState([])
  // ADD PRICE
  const [showAddItemPriceModal, setShowAddItemPriceModal] = useState(false)
  const handleShowAddItemPriceModal = () => setShowAddItemPriceModal(true)
  const handleCloseAddItemPriceModal = () => {
    setShowAddItemPriceModal(false)
  }

  // DATA HANDLERS
  const [forwarders, setForwarders] = useState([])
  const [allIngredients, setAllIngredients] = useState([])
  const [categories, setCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [brand, setBrand] = useState([])
  // const [itemDetails, setItemDetails] = useState({
  //   name: "",
  //   type: "",
  //   detail: "",
  // });
  const [itemDetails, setItemDetails] = useState({
    name: "",
    type: "",
    detail: "",
    added_by: getUser(),
    added_on: formatDate(),
    category: [{ value: "" }],
    category_options: [{ value: "" }],
  })
  const [itemsUnits, setItemsUnits] = useState([
    {
      unit_from: "",
      value_from: "",
      unit_to: "",
      value_to: "",
      minimum: "",
      maximum: "",
      acceptable_variance: "",
    },
  ])
  //ADD ITEM ERROR HANDLING
  const [isErrorItem, setIsErrorItem] = useState({
    name: false,
    inhouse_barcode: false,
    category: false,
    sales_type: false,
  })
  // ADD ITEM MODAL
  const [showAddItemModal, setShowAddItemModal] = useState(false)
  const handleShowAddItemModal = () => setShowAddItemModal(true)
  const handleCloseAddItemModal = () => setShowAddItemModal(false)
  // ADD Conversion
  const [showAddConversionModal, setShowAddConversionModal] = useState(false)
  const handleShowAddConversionModal = () => setShowAddConversionModal(true)
  const handleCloseAddConversionModal = () => setShowAddConversionModal(false)
  const [formErrors, setFormErrors] = useState({})

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    received_date: false,
    invoice_no: false,
    dr_no: false,
    // items
    received_items_table: false,
    qtyInput: false,
    price: false,
    qty: false,
    addtl_price: false,
  })

  // SELECT DROPSEARCH HANDLERS
  const [forwarderValue, setForwarderValue] = useState({
    name: "forwarder_id",
    label: "",
    value: "",
  })

  // SELECT DROPDOWN CHANGE
  const handleSelectDropdownChange = (e, action, index) => {
    if (e.name === "category" || e.name === "subcategory") {
      // if category/subcategory ma save siya sud sa categories array
      var categories = [...itemDetails.category]
      // para if mo select siya ug another subcategory ma reset iya child
      if (
        categories[index]?.value ? categories[index]?.value !== e.value : false
      ) {
        categories.splice(index)
      }
      // para ma set ang value sa selected category
      categories[index] = { value: e.value, label: e.label }
      fetchSubcategories(e.id, categories, "add", index)
      setItemDetails({
        ...itemDetails,
        ["category"]: categories,
        // [e.name]: e.value,
        [`${e.name}_id`]: e.id,
        // [e.selected_value_name]: {
        //   label: e.label,
        //   value: e.value,
        // },
      })
    } else {
      setItemDetails({
        ...itemDetails,
        [e.name]: e.value,
        [`${e.name}_id`]: e.id,
        // [e.selected_value_name]: {
        //   label: e.label,
        //   value: e.value,
        // },
      })
    }
  }

  // Function to remove an input field
  const handleRemoveSubcategory = (index, type) => {
    var categories = []
    categories = itemDetails.category

    const newInputs = [...categories]
    newInputs.splice(index) // Remove the input at the specified index
    setItemDetails({
      // Update the state with the new array
      ...itemDetails,
      ["category"]: newInputs,
    })
  }

  function handleAddItem() {
    // window.open("/items", "_blank");
    handleShowAddItemModal()
    fetchCategories()
    fetchBrands()
  }

  function handleAddSupplierClick() {
    window.open("/suppliers", "_blank")
  }

  function handleForwarderChange(e) {
    var newList = { ...addPI }
    newList[e.name] = e.value
    setAddPI(newList)
    setForwarderValue({ name: e.name, label: e.label, value: e.value })
  }

  function handleBranchChange(e) {
    var newList = { ...addPI }
    newList[e.name] = e.value
    newList["branch_id_value"] = {
      name: e.name,
      label: e.label,
      value: e.value,
    }
    setAddPI(newList)
  }

  function handleAddChange(e) {
    setIsChanged(true)
    const { name, value, checked } = e.target
    if (name === "is_vat") {
      setAddPI((prevState) => ({
        ...prevState,
        [name]: checked,
        ["vat_type"]: checked ? "VAT" : "NVAT",
        ["withholding_percentage"]: !checked
          ? 0
          : addPI.original_withholding_percentage,
      }))
    } else if (name === "withholding_percentage") {
      setAddPI((prevState) => ({
        ...prevState,
        // ["withholding_percentage"]: value === "1" ? 1 : 2,
        withholding_percentage: parseFloat(value),
      }))
    } else {
      const newList = { ...addPI }
      newList[name] = value
      setAddPI(newList)
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  // Create item onchange
  const handleAddItemChange = (e) => {
    const { name, value } = e.target

    setItemDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  // Create item onchange
  const handleAddNewItemChange = (e) => {
    const { name, value } = e.target

    setItemDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleSearch = (newValue) => {
    if (newValue.length > 2) {
      handleSearchItems(newValue, setItemsOptions)
    }
  }

  async function handleSearchItems(value, setItemsOptions) {
    setItemsOptions([])
    const response = await searchItem({ name: value })
    if (response.response) {
      var itemsList = response.response.data.map((data) => {
        var info = data
        info.label = data.name
        info.value = data.id

        return info
      })
      setItemsOptions(itemsList)
    } else {
      return toast.error(response.error?.data?.messages.message, {
        style: toastStyle(),
      })
    }
  }

  // RECEIVE ITEMS CHANGE
  function handleItemChange(e, index, search) {
    setIsChanged(true)
    if (search) {
      var item_name = itemsOptions.filter((data) => {
        return data.value === e
      })
      const list = [...itemList]
      list[index].item_id = e
      list[index].item_id_value = {
        label: item_name[0].label,
        value: item_name[0].value,
      }
      list[index]["unit"] = item_name[0]?.item_units[0]?.unit_to
      setItemList(list)
    } else {
      const { name, value } = e.target
      setIsChanged(true)
      itemList[index][name] = value
      if (
        itemList[index].qtyInput &&
        itemList[index].price &&
        itemList[index].discount_percentage
      ) {
        var tempTotal =
          parseFloat(itemList[index].qtyInput) *
          parseFloat(itemList[index].price)
        var tempDiscount =
          tempTotal * (parseFloat(itemList[index].discount_percentage) / 100)
        itemList[index].amount = (tempTotal - tempDiscount).toString()
        itemList[index].discount_amount = tempDiscount.toString()
      } else {
        itemList[index].amount = "0"
        itemList[index].discount_amount = "0"
      }

      setItemList(itemList)
      setTimeout(() => setIsChanged(false), 1)
    }
  }

  // ITEM CONVERSION CHANGE
  function handleConversionChange(e, id) {
    const { name, value } = e.target
    var newItemsUnits = itemsUnits
    if (name === "unit_from") {
      var newBreakdownUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownUnit)
    } else if (name === "value_from") {
      var newBreakdownValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownValue)
    } else if (name === "unit_to") {
      var newInventoryUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_to = value
        }
        return item
      })
      setItemsUnits(newInventoryUnit)
    } else if (name === "value_to") {
      var newInventoryValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_to = value
        }
        return item
      })
      setItemsUnits(newInventoryValue)
    } else if (name === "minimum") {
      var newMinimum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.minimum = value
        }
        return item
      })
      setItemsUnits(newMinimum)
    } else if (name === "maximum") {
      var newMaximum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.maximum = value
        }
        return item
      })
      setItemsUnits(newMaximum)
    } else if (name === "acceptable_variance") {
      var newAcceptableVatriance = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.acceptable_variance = value
        }
        return item
      })
      setItemsUnits(newAcceptableVatriance)
    }
  }

  function handleAddNewRow() {
    const newItem = {
      item_id: "",
      qtyInput: "1",
      unit: "",
      price: "0",
      amount: "0",
      discount_percentage: 0,
      discount_amount: 0,
    }
    setAdditionalItemList((oldItems) => [...oldItems, newItem])
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  function handleDelRow(id) {
    setIsChanged(true)
    const newList = [...additionalItemList]
    newList.splice(id, 1)
    setAdditionalItemList(newList)
    setTimeout(() => setIsChanged(false), 1)
  }

  function handleAdditionalItemChange(e, id, search) {
    setIsChanged(true)
    if (search) {
      var item_name = itemsOptions.filter((data) => {
        return data.value === e
      })
      const list = [...additionalItemList]
      list[id].item_id = e
      list[id].item_id_value = {
        label: item_name[0].label,
        value: item_name[0].value,
      }
      list[id]["unit"] = item_name[0]?.item_units[0]?.unit_to
      list[id]["current_qty"] = item_name[0]?.item_units[0]?.current_qty
      list[id]["price"] =
        item_name[0]?.item_units[0]?.previous_item_price || "0"
      list[id]["amount"] =
        parseFloat(list[id]["qtyInput"] ? list[id]["qtyInput"] : 0) *
        parseFloat(list[id]["price"] ? list[id]["price"] : 0)
      list[id]["subtotal"] =
        parseFloat(list[id]["qtyInput"] ? list[id]["qtyInput"] : 0) *
        parseFloat(list[id]["price"] ? list[id]["price"] : 0)

      setAdditionalItemList(list)
    } else {
      const { name, value } = e.target
      const list = [...additionalItemList]
      if (
        name === "qtyInput" ||
        name === "price" ||
        name === "discount_percentage"
      ) {
        list[id][name] = value
        var tempTotal =
          parseFloat(list[id]["qtyInput"]) * parseFloat(list[id]["price"])
        var totalDiscount =
          tempTotal * (parseFloat(list[id]["discount_percentage"]) / 100)
        list[id]["subtotal"] = parseFloat(tempTotal)
        list[id]["amount"] = tempTotal - totalDiscount
        list[id]["discount_amount"] = totalDiscount
      } else {
        items.map((item, index) => {
          if (index === id) {
            list[id][name] = value
          }
        })
      }
      setAdditionalItemList(list)

      setTimeout(() => setIsChanged(false), 1)
    }
  }

  function renderAdditionalItemsTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th className="color-gray">item</th>
            <th className="color-gray">quantity</th>
            <th className="color-gray">unit</th>
            <th className="color-gray">unit price</th>
            <th className="color-gray">discount (%)</th>
            <th className="color-gray">amount</th>
            <th className="color-gray">actions</th>
          </tr>
        </thead>
        <tbody>
          {additionalItemList.map((item, index) => {
            return (
              <tr>
                <td>
                  <SearchBox
                    showSearch
                    value={item.item_id_value}
                    placeholder={"Search Item..."}
                    className="react-select-container w-full"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    onSearch={handleSearch}
                    onChange={(e) => handleAdditionalItemChange(e, index, true)}
                    notFoundContent={null}
                    options={(itemsOptions || []).map((d) => ({
                      value: d.value,
                      label: d.label,
                    }))}
                    // disabled={item.item_id?.value !== null ? true : false}
                  />
                  {/* <Select
                    options={itemsOptions}
                    defaultValue={item.item_id_value}
                    name="item_id"
                    placeholder="Choose item"
                    onChange={(e) => handleAdditionalItemChange(e, index, true)}
                    search={true}
                  /> */}
                  <InputError
                    isValid={isError.item_id}
                    message={"Item is required"}
                  />
                </td>
                <td>
                  <Form.Control
                    className="mb-1 hide-spinner numeric-input"
                    type="number"
                    name="qtyInput"
                    defaultValue={item.qtyInput}
                    onChange={(e) =>
                      handleAdditionalItemChange(e, index, false)
                    }
                  />
                  <InputError
                    isValid={isError.qtyInput}
                    message={"Qty is required"}
                  />
                </td>
                <td>
                  {/* <Form.Control
                    type="text"
                    name="unit"
                    value={item.unit}
                    disabled
                  /> */}
                  <Form.Select
                    name="unit"
                    id={item.id}
                    value={item.unit}
                    className="w-full"
                    onChange={(e) =>
                      handleAdditionalItemChange(e, index, false)
                    }
                  >
                    <option value="">Select</option>
                    {itemsOptions
                      ?.filter((info) => info.value == item.item_id)
                      .map((data) => {
                        return data.item_units.map((info) => {
                          return (
                            <option value={info.unit_to}>{info.unit_to}</option>
                          )
                        })
                      })}
                    {/* {units.map((data) => {
                          return (
                            <option value={data.unit_to}>
                              {data.unit_to}
                            </option>
                          );
                      })} */}
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="price"
                    className="hide-spinner numeric-input"
                    value={item.price}
                    onChange={(e) =>
                      handleAdditionalItemChange(e, index, false)
                    }
                  />
                  <InputError
                    isValid={isError.addtl_price}
                    message={"Price is required"}
                  />
                </td>
                <td>
                  <Form.Control
                    className="mb-1 hide-spinner"
                    type="number"
                    name="discount_percentage"
                    defaultValue={item.discount_percentage}
                    onChange={(e) =>
                      handleAdditionalItemChange(e, index, false)
                    }
                  />
                  <Form.Control
                    type="number"
                    name="discount_amount"
                    value={item.discount_amount}
                    disabled
                  />
                </td>
                {/* <td>
                </td> */}
                <td className="color-green">{numberFormat(item.amount)}</td>
                <td className="text-center">
                  <img
                    alt=""
                    src={trash}
                    onClick={() => handleDelRow(index)}
                    className="cursor-pointer"
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  // fetch items
  async function fetchItems() {
    const response = await searchItem({})
    if (response.response) {
      setItems(response.response.data)

      let result = response.response.data.map((a) => {
        return {
          label: a.name,
          value: a.id,
        }
      })
      setItemsOptions(result)
    }
  }

  async function fetchItem(id) {
    const response = await getItem(id)
    if (response.data) {
      var data = response.data[0]
      data.item_name = data.name
      data.item_id = data.id

      // to set the first array to the item units of the selected item
      const newList = [...priceLevelDetails]
      var units = data.item_units.map((data) => {
        var info = data
        info.original_cost_price = data.cost_price
        return info
      })
      newList[priceLevelDetails.length - 1] = units
      setPriceLevelDetails(newList)
      handleShowAddItemPriceModal()
      handleCloseAddConversionModal()

      if (data.item_units === false) {
        response.data.map((data) => (data.item_units = data.item_units || []))
        setItemsUnits([])
        setItemDetails(data)
      } else {
        setItemsUnits(data.item_units)
        setItemDetails(data)
      }
    } else {
      setItemDetails({})
    }
  }

  async function fetchBranches() {
    const response = await getAllBranches()

    if (response.data) {
      var tempBranches = []
      response.data.data.map((branch) => {
        var info = {}

        // if (branch.is_franchise === 3||branch.is_franchise === '3') {
        info.name = "branch_id"
        info.label = branch.name
        info.value = branch.id
        info.address = branch.address
        tempBranches.push(info)
        // }
      })
      setBranchList(tempBranches)
    }
  }

  // FUNCTION TO SAVE ITEM
  async function handleSaveItem() {
    // var hasUnits = itemsUnits.length > 0 ? true : false;
    if (validateItems(itemDetails, setIsErrorItem)) {
      setIsClicked(true)
      const response = await createItem(itemDetails, itemsUnits)
      if (response.response) {
        setItemDetails((prevState) => ({
          ...prevState,
          id: response.response.item_id,
        }))
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        handleCloseAddItemModal()
        handleShowAddConversionModal()
        setIsClicked(false)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
  }
  // FUNCTION TO SAVE ITEM CONVERSION
  async function handleAddConversion() {
    setIsClicked(true)

    const response = await editItem(itemDetails, itemsUnits)
    if (response.response) {
      var details = { ...itemDetails }
      details.item_id = response.response.item_id
      details.item_unit_id = response.response.item_unit_id
      details.unit = response.response.unit
      details.unit_from = itemsUnits.unit_from
      details.unit_to = itemsUnits.unit_to
      setItemDetails(details)
      fetchItem(response.response.item_id)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  // ADD CONVERSION TABLE
  function renderTableConversion() {
    return (
      <Table>
        <thead>
          <tr>
            <th>
              VALUE 1 - Warehouse Unit<span className="required">*</span>
            </th>
            <th> </th>
            <th>
              VALUE 2 - Store Unit<span className="required">*</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {itemsUnits.map((item, index) => {
            return (
              <tr>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                      // disabled
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                      // disabled
                    />
                  </Col>
                </td>

                <td>
                  <img src={equal} className="cursor-pointer" alt="equal to" />
                </td>

                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_from"
                      className="nc-modal-custom-input hide-spinner numeric-input"
                      onChange={(e) => handleConversionChange(e, index)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_from"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                    />
                  </Col>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function handleAddItem() {
    // window.open("/items", "_blank");
    handleShowAddItemModal()
    fetchCategories()
    fetchBrands()
  }

  // FUNCTION FETCH ITEM CATEGORIES
  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.name = "category"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
    }
  }

  async function fetchSubcategories(id, categories, type, index) {
    setSubCategories([])
    const response = await getSubcategory(id)
    if (response.data) {
      //subcategories
      var subcategories = response.data.data.map((category) => {
        var info = {}
        info.name = "subcategory"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)

      // to set categories and options
      const options = [...itemDetails.category_options] // Create a copy of the options array
      options[index + 1] = subcategories // Update the value at the specified index

      setItemDetails({
        ...itemDetails,
        ["category"]: [...categories, ""],
        ["category_options"]: [...options],
      })
    } else {
      //display error toast message if status code is 400
      response.error?.response?.data?.messages.map((data) => {
        // return toast.error(data);
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  // FUNCTION FETCH ITEM BRAND
  async function fetchBrands() {
    const response = await getBrand({})
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.name = "brand"
        info.value = brand.name
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands)
    }
  }

  const handleTypeaheadChange = (e, labelKey) => {
    if (e[0] !== undefined) {
      if (e[0].customOption) {
        setItemDetails((prevState) => ({
          ...prevState,
          [labelKey]: e[0].value,
          [`${labelKey}_id`]: "",
          [`selected_${labelKey}`]: [e[0]],
        }))
      } else {
        setItemDetails((prevState) => ({
          ...prevState,
          [e[0].name]: e[0].value,
          [`${labelKey}_id`]: e[0].id,
          [`selected_${labelKey}`]: [e[0]],
        }))
      }
    } else if (e === undefined || e === null || e.length === 0) {
      setItemDetails((prevState) => ({
        ...prevState,
        [labelKey]: "",
        [`${labelKey}_id`]: "",
        [`selected_${labelKey}`]: [],
      }))
    }
  }

  console.log(addPI)

  async function handleCreatePI() {
    const allItems = []
    itemList.map((item) => {
      var info = item
      info.po_item_id = item.id
      allItems.push(info)
    })
    if (additionalItemList.length > 0) {
      additionalItemList.map((item) => {
        var info = item
        info.qtyInput = item.qtyInput
        info.description = ""
        info.po_item_id = "0"
        allItems.push(info)
      })
    }
    const errors = {}
    // const finalItems = []
    itemList.map((item, itemIndex) => {
      if (
        item.item_id === "" ||
        item.item_id === undefined ||
        item.item_id === null
      ) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          description: "Item is required",
        }
      }

      if (!item.qtyInput.toString() || item.qtyInput === "") {
        // if (!item.qtyInput) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          qtyInput: "Qty is required",
        }
      }

      if (!item.price) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          price: "Price is required",
        }
      }
    })
    setFormErrors(errors)

    if (
      validateFormPurchaseInvoice(
        addPI,
        itemList,
        additionalItemList,
        setIsError
      ) &&
      Object.keys(errors).length === 0
    ) {
      setIsClicked(true)
      addPI.attachments = fileList
      const response = await createInvoice(addPI, allItems, po_id)
      if (response.error) {
        response.error?.data?.messages.map((data) => {
          return toast.error(data)
        })
      } else {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(
          () => navigate("/purchaseinvoices/print/" + response.data.receive_id),
          1000
        )
      }
      setIsClicked(false)
    } else {
      setIsClicked(false)
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      })
    }
  }

  async function handleUpdatePI() {
    const allItems = []

    itemList.map((item) => {
      var info = item
      info.id = item.id
      info.qtyInput = item.qtyInput ? item.qtyInput : item.remaining_qty
      allItems.push(info)
    })
    if (additionalItemList.length > 0) {
      additionalItemList.map((item) => {
        var info = item
        info.po_item_id = "0"
        allItems.push(info)
      })
    }
    if (isClicked) {
      return
    }
    if (
      validateFormPurchaseInvoice(
        addPI,
        itemList,
        additionalItemList,
        setIsError
      )
    ) {
      setIsClicked(true)
      addPI.attachments = fileList
      addPI.prev_files = prevAttachments
      const response = await updateInvoice(addPI, allItems, pi_id)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(() => navigate("/purchaseinvoices"), 1000)
      } else {
        response.error?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all required fields", { style: toastStyle() })
    }
  }

  const handleSubmit = () => {
    if (add) handleCreatePI()
    else if (edit) handleUpdatePI()
  }

  /** FOR ADD - Fetch Purchase Order Details */
  async function fetchPO() {
    setAddPI({})
    setItemList([])
    setIsChanged(true)

    const response = await getPurchaseOrder(po_id)

    if (response.error) {
      TokenExpiry(response)
    } else {
      var PO = response.response.data[0]
      PO.received_date = getTodayDateISO()
      PO.purchase_date = PO.purchase_date.split(" ")[0]
      PO.discount = PO.discount ? PO.discount : "0"
      PO.service_fee = PO.service_fee ? PO.service_fee : "0"
      if (PO.payment_status === "open") {
        PO.is_vat = PO.vat_type === "VAT" ? true : false
        PO.withholding_percentage = parseFloat(PO.withholding_percentage)
        PO.original_withholding_percentage = parseFloat(PO.withholding_percentage)
      } else {
        PO.is_vat = false
        PO.vat_type = "NVAT"
        PO.withholding_percentage = 0
        PO.original_withholding_percentage = 0
      }
      PO.branch_id_value = {
        label: PO.branch_name,
        value: PO.branch_id,
      }
      console.log(PO.branch_id_value)

      PO.item_total = PO.purchase_items
        .map((item) => item.amount)
        .reduce((a, b) => parseInt(a) + parseInt(b), 0)

      var receivedItems = PO.purchase_items.map((item) => {
        var info = item
        info.has_item = item.item_id === null ? false : true
        // info.item_id = {
        //   value: item.item_id,
        //   label: item.item_name,
        // };
        info.discount_percentage = item.discount_percentage || "0"
        info.discount_amount = item.discount_amount || "0"
        info.amount =
          parseFloat(item.remaining_qty) * parseFloat(item.price) -
          parseFloat(item.discount_amount)
        info.qtyInput = item.remaining_qty
        info.subtotal = item.subamount

        return info
      })
      PO.remarks = ""
      PO.invoice_no = ""
      PO.dr_no = ""

      setAddPI(PO)
      setItemList(receivedItems)
      setForwarderValue({
        name: "forwarder_id",
        label: PO.forwarder_name,
        value: PO.forwarder_id,
      })
    }
    setTimeout(() => setIsChanged(false), 100)
  }

  /** FOR EDIT - Fetch Purchase Invoice Details */
  async function fetchPI() {
    setPrevAttachments([])
    setIsChanged(true)
    const response = await getInvoice(pi_id)
    if (response.data) {
      var PI = response.data.data[0]
      setAddPI(PI)

      var itemsReceived = []
      var additionalReceived = []

      var itemReceivedTotal = 0
      var additionalReceivedTotal = 0
      PI.branch_id_value = {
        label: PI.branch_name,
        value: PI.branch_id,
      }
      if (PI.receive_items) {
        PI.receive_items = PI.receive_items.map((receive_item) => {
          var item = receive_item
          item.discount_percentage = receive_item.discount_percentage || "0"
          item.discount_amount = receive_item.discount_amount || "0"
          item.subtotal = receive_item.subamount
          item.qtyInput = receive_item.qty
          item.item_id_value = {
            label: receive_item.item_name,
            value: receive_item.item_id,
          }
          return item
        })

        PI.receive_items.map((receive_item) => {
          var item = receive_item

          if (item.po_item_id !== "0") {
            itemReceivedTotal = itemReceivedTotal + parseFloat(item.total)
            itemsReceived.push(item)
          } else {
            item.qtyInput = item.qty
            item.item_id_value = {
              label: receive_item.item_name,
              value: receive_item.item_id,
            }
            additionalReceivedTotal =
              additionalReceivedTotal + parseFloat(item.total)
            additionalReceived.push(item)
          }
        })
      }

      PI.received_date = PI.receive_date
      PI.supplier_trade_name = PI.supplier_name
      PI.item_total = itemReceivedTotal
      PI.additional_item_total = additionalReceivedTotal
      PI.is_vat = PI.vat_type === "VAT" ? true : false
      PI.withholding_percentage = parseFloat(PI.withholding_percentage)
      PI.original_withholding_percentage = parseFloat(PI.withholding_percentage)

      setItemList(itemsReceived)

      setAdditionalItemList(additionalReceived)
      setForwarderValue({
        name: "forwarder_id",
        label: PI.forwarder_name,
        value: PI.forwarder_id,
      })
      setPrevAttachments(PI.receive_attachments)
    } else {
      TokenExpiry(response)
    }
    setTimeout(() => setIsChanged(false), 1)
  }

  async function fetchForwarders() {
    setForwarders([])

    const response = await getAllForwarders()

    if (response.data) {
      var forwarders = response.data.data.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )

      forwarders.map((forwarder) => {
        var info = {}

        info.name = "forwarder_id"
        info.label = forwarder.name
        info.value = forwarder.id

        setForwarders((prev) => [...prev, info])
      })
    } else {
      TokenExpiry(response)
    }
  }

  // async function fetchIngredients() {
  //   const response = await searchItem({});
  //   if (response?.response?.data) {
  //     var ingredients = response.response.data.sort((a, b) =>
  //       a.name > b.name ? 1 : b.name > a.name ? -1 : 0
  //     );
  //     setAllIngredients(ingredients);

  //     var cleanedItems = ingredients.map((ing) => {
  //       var info = {};
  //       info.name = "item_id";
  //       info.label = ing.name;
  //       info.value = ing.id;
  //       info.price = ing.price;
  //       info.unit_to = ing.unit_to;
  //       info.unit_from = ing.unit_from;
  //       return info;
  //     });
  //   } else {
  //     TokenExpiry(response);
  //   }
  // }

  // DATA FETCHING
  useEffect(() => {
    if (edit) {
      fetchPI()
    } else if (add) {
      fetchPO()
    }
    fetchBranches()
    // fetchItems()
    fetchPriceLevel()
    fetchForwarders()
    // fetchIngredients();
  }, [])

  useEffect(() => {
    if (showAddItemModal) {
      var subcat = subCategories.filter((data) => {
        return data.category_id === itemDetails?.category_id
      })
      setFilteredSubCategories(subcat)
    }
  }, [itemDetails.category])

  // FOR DYNAMIC CALCULATION
  useEffect(() => {
    var calcSubtotal = 0
    var calcDiscountSubtotal = 0
    var tempDiscount = addPI.discount ? parseFloat(addPI.discount) : 0
    var tempServiceFee = addPI.service_fee ? parseFloat(addPI.service_fee) : 0

    if (itemList && !additionalItemList) {
      calcSubtotal = itemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
    } else if (!itemList && additionalItemList) {
      calcSubtotal = additionalItemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
    } else if (itemList && additionalItemList) {
      let temp = additionalItemList
      temp.map((item, index) => {
        item.amount = item.qtyInput * item.price - item.discount_amount
      })
      setAdditionalItemList(temp)

      var itemListSubtotal = itemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
      var additionalItemListSubtotal = additionalItemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)

      // item subtotal with discount per item
      calcSubtotal = itemListSubtotal + additionalItemListSubtotal
      // item subtotal with discount
      calcDiscountSubtotal = calcSubtotal - tempDiscount
    }

    var _wht = 0
    var vatable_sales = 0
    var vat = 0

    if (addPI.vat_type === "VAT") {
      vatable_sales = parseFloat(calcDiscountSubtotal) / 1.12
      vat = parseFloat(calcDiscountSubtotal) - vatable_sales
      var percentage =
        addPI?.withholding_percentage === 0.5
          ? 0.005
          : addPI?.withholding_percentage === 1
          ? 0.01
          : addPI?.withholding_percentage === 2
          ? 0.02
          : 0

      // witholding tax if vat is checked
      var tempVatSales = vatable_sales ? parseFloat(vatable_sales) : 0
      var tempWHTPercentage = percentage ? parseFloat(percentage) : 0
      _wht = parseFloat(tempVatSales) * tempWHTPercentage
    }
    var _grand_total_without_fee = calcDiscountSubtotal - _wht

    setAddPI((prev) => {
      return {
        ...prev,
        grand_total: _grand_total_without_fee + tempServiceFee,
        // grand_total: calcSubtotal + tempServiceFee - tempDiscount,
        subtotal: calcSubtotal.toFixed(2),
        withholding_tax: _wht,
        discounted_subtotal: calcDiscountSubtotal.toFixed(2),
        grandtotal_without_service_fee: _grand_total_without_fee,
        vat: vat,
        vatable_sales: vatable_sales,
      }
    })
  }, [isChanged])

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  // ADD PRICE LEVEL HANDLER
  function handleAddPriceLevel() {
    var newList = []
    var units = itemDetails.item_units.map((data) => {
      var info = data
      info.original_cost_price = data.cost_price
      return info
    })
    newList = units

    setPriceLevelDetails((oldItems) => [...oldItems, newList])
  }

  // PRICE LEVEL REMOVAL HANDLER
  function handleRemovePriceLevel(id) {
    const rowId = id
    const newItemList = [...priceLevelDetails]
    newItemList.splice(rowId, 1)
    setPriceLevelDetails(newItemList)

    // to filter price level and remove the selected ones in the option
    const flattenedNewList = newItemList.flat() // Flatten the nested arrays
    const filteredOptions = priceLevel.filter((option) => {
      // Check if any object in flattenedNewList has the same price_level_id
      return !flattenedNewList.some(
        (item) => item.price_level_id === option.value
      )
    })

    setFilteredPriceLevels(filteredOptions)
  }

  // updated price level details change
  const handlePriceLevelChange = (e, type, level_index, unit_index) => {
    if (type === "price_level") {
      const { name, value, label } = e
      const newList = [...priceLevelDetails]

      const updatedList = newList.map((subArray, index) => {
        if (index === level_index) {
          // If the current subArray index matches the level_index, update its elements
          return subArray.map((item) => ({
            ...item,
            price_level_id: value,
            price_level_id_value: {
              label: label,
              value: value,
            },
          }))
        }
        return subArray // If not the targeted index, return the subArray unchanged
      })
      // to set select dropdown value
      updatedList[level_index]["price_level_id_value"] = {
        label: label,
        value: value,
      }
      setPriceLevelDetails(updatedList)

      // to filter price level and remove the selected ones in the option
      const flattenedNewList = updatedList.flat() // Flatten the nested arrays
      const filteredOptions = priceLevel.filter((option) => {
        // Check if any object in flattenedNewList has the same price_level_id
        return !flattenedNewList.some(
          (item) => item.price_level_id === option.value
        )
      })

      setFilteredPriceLevels(filteredOptions)
    } else {
      const { name, value } = e.target

      const newList = [...priceLevelDetails]
      newList[level_index][unit_index][name] = value

      if (name === "margin") {
        var margin = value !== "" ? value : 0
        var cost_price = newList[level_index][unit_index]["cost_price"]
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["margin"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      } else if (name === "cost_price") {
        var margin = newList[level_index][unit_index]["margin"]
          ? newList[level_index][unit_index]["margin"]
          : 0
        var cost_price = value !== "" ? value : 0
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["cost_price"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      }
      setPriceLevelDetails(newList)
    }
  }

  // FUNCTION TO SAVE ITEM PRICE
  async function handleSaveItemPrice() {
    setIsClicked(true)
    const response = await createItemPrice(itemDetails, priceLevelDetails)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      handleCloseAddItemPriceModal()
      setItemDetails({})
      setItemsUnits([])
      // fetchItems()
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  async function fetchPriceLevel() {
    setPriceLevels([])
    const response = await getAllPriceLevels()
    if (response.data) {
      var price_levels = response.data.data.map((data) => {
        var info = {}
        info.var_name = "price_level_id"
        info.for = "price_level_id_value"
        info.label = data.name
        info.value = data.id
        return info
      })
      setPriceLevels(price_levels)
      setFilteredPriceLevels(price_levels)
    }
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* header */}

        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              {add ? "ADD " : "EDIT "}PURCHASE INVOICE{" "}
            </h1>
          </Col>
          <Col xs={12} lg={3}>
            <span className="PI-header2">
              PURCHASE ORDER NO. {add ? po_id : addPI.po_id}
            </span>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          {/* PURCHASE INVOICE DETAILS */}
          <Fragment>
            <Row>
              <Col xs={12} lg={6}>
                <span className="edit-label">Supplier Name</span>
                <Form.Control
                  type="text"
                  name="supplier_trade_name"
                  className="nc-modal-custom-text"
                  value={
                    addPI.supplier_trade_name
                      ? addPI.supplier_trade_name
                      : addPI.vendor_name
                      ? addPI.vendor_name
                      : addPI.vendor_trade_name
                  }
                  disabled
                />
              </Col>
              <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                <span className="edit-label">Purchase Date</span>
                <Form.Control
                  type="date"
                  name="purchase_date"
                  className="nc-modal-custom-text"
                  value={addPI.purchase_date}
                  disabled
                />
              </Col>
              <Col xs={6} lg={3} className="mt-3 mt-lg-0">
                <span className="edit-label">Received Date</span>
                <Form.Control
                  type="date"
                  name="received_date"
                  className="nc-modal-custom-text"
                  value={addPI.received_date}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.received_date}
                  message={"Received date is required"}
                />
              </Col>
            </Row>
            <Row className="my-3">
              <Col xs={12} lg={6} className="mt-3 mt-lg-0">
                <span className="edit-label">
                  Branch <label className="badge-required">{` *`}</label>{" "}
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Branch..."
                  value={addPI.branch_id_value}
                  options={branchList}
                  onChange={(e) => handleBranchChange(e)}
                />
                <InputError
                  isValid={isError.branch_id}
                  message={"Branch is required"}
                />
                {/* <Form.Control
                    type="text"
                    name="branch_name"
                    className="nc-modal-custom-text"
                    defaultValue={addPI.branch_name}
                    disabled
                  /> */}
              </Col>
              <Col xs={12} lg={6} className="mt-3 mt-lg-0">
                <span className="edit-label">Forwarder</span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Forwarder..."
                  value={forwarderValue}
                  options={forwarders}
                  onChange={(e) => handleForwarderChange(e)}
                />
              </Col>
            </Row>
            <Row className="d-flex flex-row justify-content-start align-items-start">
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">Waybill No.</span>
                <Form.Control
                  type="text"
                  name="waybill_no"
                  className="nc-modal-custom-text"
                  value={addPI.waybill_no}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">Invoice No.</span>
                <Form.Control
                  type="text"
                  name="invoice_no"
                  className="nc-modal-custom-text"
                  value={addPI.invoice_no}
                  onChange={(e) => handleAddChange(e)}
                  required
                />
                <InputError
                  isValid={isError.invoice_no}
                  message={"Either invoice no. or DR no. is required"}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="edit-label">DR No.</span>
                <Form.Control
                  type="text"
                  name="dr_no"
                  className="nc-modal-custom-text"
                  value={addPI.dr_no}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.dr_no}
                  message={"Either invoice no. or DR no. is required"}
                />
              </Col>
            </Row>
          </Fragment>

          {/* RECEIVED ITEM TABLE */}
          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">Received Items</span>
              <div className="edit-purchased-items">
                {itemList.length !== 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <th>item</th>
                        <th>quantity</th>
                        <th>unit</th>
                        <th>unit price</th>
                        <th>discount</th>
                        {/* <th>discount amt</th> */}
                        <th>total amount</th>
                        <th>ordered</th>
                        <th>previously received</th>
                        <th>balance</th>
                        <th>remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemList.map((item, index) => {
                        return (
                          <tr>
                            <td>
                              {/* <td> */}
                              <Form.Control
                                type="text"
                                name="description"
                                className="nc-modal-custom-input mb-1"
                                value={item.description}
                                onChange={(e) =>
                                  handleItemChange(e, index, false)
                                }
                                placeholder="Description"
                                disabled={item.has_item}
                              />
                              {/* </td> */}
                              {item.has_item ? (
                                <td>{item.item_name}</td>
                              ) : (
                                // <Form.Control
                                //   type="text"
                                //   name="item_id"
                                //   className="nc-modal-custom-input mb-1"
                                //   value={item.item_name}
                                //   placeholder="Item Name"
                                //   disabled
                                // />
                                <>
                                  <SearchBox
                                    showSearch
                                    value={item.item_id_value}
                                    placeholder={"Search Item..."}
                                    className="react-select-container w-full"
                                    dropdownClassName="z-large antdesign-custom-dropdown"
                                    style={antdesignSelectStyle}
                                    defaultActiveFirstOption={false}
                                    suffixIcon={null}
                                    filterOption={false}
                                    onSearch={handleSearch}
                                    onChange={(e) =>
                                      handleItemChange(e, index, true)
                                    }
                                    notFoundContent={null}
                                    options={(itemsOptions || []).map((d) => ({
                                      value: d.value,
                                      label: d.label,
                                    }))}
                                    // disabled={item.item_id?.value !== null ? true : false}
                                  />
                                  {formErrors[index] &&
                                    formErrors[index].description && (
                                      <div className="validity-error callout bottom">
                                        {formErrors[index].description}
                                      </div>
                                    )}
                                  {/* <Select
                                    options={itemsOptions}
                                    defaultValue={item.item_id_value}
                                    name="item_id"
                                    placeholder="Choose item"
                                    onChange={(e) => handleItemChange(e, index, true)}
                                    search={true}
                                    disabled={item.item_id?.value !== null ? true : false}
                                  /> */}
                                </>
                              )}
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                min="0"
                                name="qtyInput"
                                className="hide-spinner numeric-input"
                                defaultValue={
                                  add
                                    ? numberFormatInt(item.remaining_qty)
                                    : numberFormatInt(item.qtyInput)
                                }
                                onChange={(e) => handleItemChange(e, index)}
                              />
                              {formErrors[index] &&
                                formErrors[index].qtyInput && (
                                  <div className="validity-error callout bottom">
                                    {formErrors[index].qtyInput}
                                  </div>
                                )}
                            </td>
                            <td>{item.unit}</td>
                            <td>
                              <Form.Control
                                type="number"
                                min="0"
                                name="price"
                                className="hide-spinner numeric-input"
                                value={item.price}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                              {formErrors[index] && formErrors[index].price && (
                                <div className="validity-error callout bottom">
                                  {formErrors[index].price}
                                </div>
                              )}
                            </td>
                            <td>
                              <Form.Control
                                className="mb-1q"
                                type="number"
                                name="discount_percentage"
                                defaultValue={item.discount_percentage}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                              <Form.Control
                                type="number"
                                name="discount_amount"
                                value={item.discount_amount}
                                onChange={(e) => handleItemChange(e, index)}
                                disabled
                              />
                            </td>
                            <td className="color-green">
                              PHP{" "}
                              {item.amount
                                ? numberFormat(
                                    parseFloat(item.amount).toFixed(2)
                                  )
                                : "0"}
                            </td>
                            <td>{item.qty ? parseInt(item.qty) : "0"}</td>
                            <td>
                              {item.received_qty ? item.received_qty : "0"}
                            </td>
                            <td>
                              {item.remaining_qty ? item.remaining_qty : "0"}
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="remarks"
                                className="nc-modal-custom-input mb-1 w-full"
                                value={item.remarks}
                                onChange={(e) =>
                                  handleItemChange(e, index, false)
                                }
                                placeholder="remarks"
                                // disabled
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div className="entries-not-found">
                    There is no received items recorded.
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <span className="edit-label" style={{ color: "#df1227" }}>
              Item Not Found?{" "}
              <a onClick={handleAddItem} className="add-supplier-label">
                add item
              </a>
            </span>
          </div>

          {/* ADDITIONAL RECEIVED ITEM TABLE */}
          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">Additional Received Items</span>
              <div className="edit-purchased-items">
                {additionalItemList.length !== 0 ? (
                  renderAdditionalItemsTable()
                ) : (
                  <div className="entries-not-found">
                    There is no additional received items recorded yet.
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {/* ADD ITEM BUTTON */}
          <Row className="pt-3 PO-add-item">
            <Col>
              <Button type="button" onClick={() => handleAddNewRow()}>
                Add Item
              </Button>
            </Col>
          </Row>

          {/* SUBTOTAL, FREIGHT COST, DISCOUNT, & GRAND TOTAL */}
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Subtotal</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(addPI.subtotal)}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Discount</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="discount"
                value={addPI.discount}
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                disabled={addPI.payment_status === "closed" ? true : false}
              />
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Discounted Subtotal</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(addPI.discounted_subtotal)}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={5} lg={6}></Col>
            <Col xs={3} lg={1} className="text-end print-table-footer-label">
              <Form.Group className="" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="VAT"
                  name="is_vat"
                  className="pt-2"
                  checked={addPI.vat_type === "VAT"}
                  onChange={(e) => handleAddChange(e)}
                  disabled={addPI.payment_status === "closed" ? true : false}
                  // disabled
                />
              </Form.Group>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end print-table-footer-data ps-4">
              {addPI.vat ? numberFormat(addPI.vat) : "0.00"}
            </Col>
          </Row>
          {addPI.vat_type === "VAT" && (
            <>
              <Row className="align-right pt-3">
                <Col xs={8} className="text-end print-table-footer-label">
                  Vatable Sales
                </Col>
                <Col xs={1} className="text-end">
                  <span className="edit-label align-middle">PHP</span>
                </Col>
                <Col xs={3} className="text-end print-table-footer-data ps-4">
                  {addPI.vatable_sales
                    ? numberFormat(addPI.vatable_sales)
                    : "0.00"}
                </Col>
              </Row>
              <Row className="align-right pt-3">
                <Col
                  xs={2}
                  lg={3}
                  className="text-end pt-2 print-table-footer-label"
                >
                  WHT
                </Col>
                <Col
                  xs={3}
                  lg={1}
                  className="text-end print-table-footer-label"
                >
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="0.5%"
                      name="withholding_percentage"
                      value="0.5"
                      className="pt-2"
                      style={{ marginLeft: "2rem" }}
                      checked={addPI.withholding_percentage === 0.5}
                      onChange={(e) => handleAddChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col
                  xs={3}
                  lg={1}
                  className="text-end print-table-footer-label"
                >
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="1%"
                      name="withholding_percentage"
                      value="1"
                      className="pt-2"
                      style={{ marginLeft: "2rem" }}
                      checked={addPI.withholding_percentage === 1}
                      onChange={(e) => handleAddChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col
                  xs={3}
                  xl={1}
                  className="text-end print-table-footer-label"
                >
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="2%"
                      name="withholding_percentage"
                      value="2"
                      className="pt-2"
                      style={{ marginLeft: "2rem" }}
                      checked={addPI.withholding_percentage === 2}
                      onChange={(e) => handleAddChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col xs={1} className="text-end">
                  <span className="edit-label align-middle">PHP</span>
                </Col>
                <Col xs={3} className="text-end print-table-footer-data ps-4">
                  {addPI.withholding_tax
                    ? numberFormat(addPI.withholding_tax)
                    : "0.00"}
                </Col>
              </Row>
            </>
          )}
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Grand Total</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {addPI.grandtotal_without_service_fee
                  ? numberFormat(addPI.grandtotal_without_service_fee)
                  : "0.00"}
              </span>
            </Col>
          </Row>
          {/* <Row className="align-right pt-3">
              <Col xs={2} className="text-end">
                <span className="edit-label color-gray">Freight Cost</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="number"
                  name="freight_cost"
                  value={addPI.freight_cost}
                  className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row> */}
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">
                Delivery/Service Fee
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="service_fee"
                value={addPI.service_fee}
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                disabled={addPI.payment_status === "closed" ? true : false}
              />
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">TOTAL AMOUNT DUE</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(addPI.grand_total)}
              </span>
            </Col>
          </Row>

          <Row className="mt-4 mb-2">
            <Col>
              <span className="edit-label">
                Remarks
                <span className="edit-optional px-2">(Optional)</span>
              </span>
              <Form.Control
                as="textarea"
                name="remarks"
                value={addPI.remarks}
                className="nc-modal-custom-text"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>

          {edit && (
            <>
              <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                <Row className="">
                  {prevAttachments &&
                    prevAttachments.map((attachment) => (
                      <Col
                        xs={1}
                        onClick={() => {
                          setPreviewFile(attachment.file_url)
                          setPreview(true)
                        }}
                        className="cursor-pointer preview-container"
                      >
                        <img
                          src={attachment.file_url}
                          className="img-preview"
                        />
                      </Col>
                    ))}
                  {!prevAttachments ||
                    (prevAttachments.length === 0 && (
                      <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img
                            src={noDataImg}
                            alt="no data found"
                            className="img-preview"
                          />
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </>
          )}
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/purchaseinvoices")}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>

      {/* ADD ITEM MODAL */}
      <AddModal
        title={`ITEM`}
        type="item"
        show={showAddItemModal}
        onHide={handleCloseAddItemModal}
        onSave={handleSaveItem}
        isClicked={isClicked}
      >
        <div className=" mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DESCRIPTION
            </span>
            <Col>
              ITEM NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
              <InputError
                isValid={isErrorItem.name}
                message={"Item name is required"}
              />
            </Col>
            <Col>
              BRAND
              <Typeahead
                id="basic-typeahead-single"
                name="value"
                labelKey="value"
                allowNew
                className="nc-modal-custom-text"
                onChange={(e) => handleTypeaheadChange(e, "brand")}
                options={brand}
                placeholder="Select/type a brand..."
                selected={itemDetails.selected_brand}
              />
            </Col>
            <Col>
              MODEL
              <Form.Control
                type="text"
                name="model"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>
              MATERIAL
              <Form.Control
                type="text"
                name="material"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
            <Col>
              COLOR
              <Form.Control
                type="text"
                name="color"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
            <Col>
              SIZE
              <Form.Control
                type="text"
                name="size"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DETAILS
            </span>
            <Col>
              BARCODE
              <Form.Control
                type="text"
                name="barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
            <Col>
              INHOUSE BARCODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="inhouse_barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
              <InputError
                isValid={isErrorItem.inhouse_barcode}
                message={"Inhouse barcode is required"}
              />
            </Col>
            <Col>
              SERIAL NUMBER
              <Form.Control
                type="text"
                name="serial_number"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>
              TAG
              <Form.Control
                type="text"
                name="tag"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
            <Col>
              ITEM CODE
              <Form.Control
                type="text"
                name="tag"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddItemChange(e)}
                required
              />
            </Col>
            <Col>
              SALES TYPE
              <span className="required"> * </span>
              <select
                name="sales_type"
                className="ms-0 nc-modal-custom-select nc-modal-custom-input-edit "
                onChange={(e) => handleAddItemChange(e)}
              >
                <option hidden selected className="nc-modal-custom-select">
                  Select
                </option>
                <option value="wholesale"> Wholesale </option>
                <option value="retail"> Retail </option>
                <option value="universal"> Both </option>
              </select>
              <InputError
                isValid={isErrorItem.sales_type}
                message={"Sales type is required"}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM CATEGORY
            </span>
            {itemDetails?.category?.map((data, index) => {
              return (
                <Col xs={3}>
                  {index === 0 ? "CATEGORY" : "SUB-CATEGORY"}
                  <Row className="align-middle">
                    <Col xs={10}>
                      <Select
                        name="subcategories"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select..."
                        value={data}
                        options={
                          index === 0
                            ? categories
                            : itemDetails?.category_options[index]
                        }
                        // options={filteredSubCategories}
                        onChange={(e) =>
                          handleSelectDropdownChange(e, "add", index)
                        }
                      />
                      <InputError
                        isValid={isError.category}
                        message={"Category is required"}
                      />
                    </Col>
                    {index !== 0 && (
                      <Col xs={2}>
                        <img
                          src={trash}
                          alt="delete"
                          onClick={() => handleRemoveSubcategory(index, "add")}
                          className="cursor-pointer mt-2"
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
              )
            })}
          </Row>
          <Row></Row>
        </div>
      </AddModal>
      {/* ADD CONVERSION MODAL */}
      <AddModal
        title={`UNIT OF MEASURE CONVERSION`}
        type="item"
        show={showAddConversionModal}
        onHide={handleCloseAddConversionModal}
        onSave={handleAddConversion}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mb-0">
            <Col>UNIT OF MEASURE CONVERSION</Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <div className="edit-purchased-items justify-content-center">
              <div className="not-found mt-0 ">
                {itemsUnits.length === 0 ? (
                  <span> No unit of measure conversion found! </span>
                ) : (
                  renderTableConversion()
                )}
              </div>
            </div>
          </Row>
        </div>
      </AddModal>
      <AddModal
        title={`ITEM PRICE`}
        type="item"
        show={showAddItemPriceModal}
        onHide={handleCloseAddItemPriceModal}
        onSave={handleSaveItemPrice}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={6}>
              ITEM NAME
              <Form.Control
                type="text"
                name="name"
                value={itemDetails.name}
                className="nc-modal-custom-input"
                disabled
              />
            </Col>
          </Row>
          <hr />
          {priceLevelDetails?.map((data, key) => {
            return (
              <>
                <Row className="nc-modal-custom-row mt-3">
                  <Col xs={6}>
                    PRICE LEVEL
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select item..."
                      value={data.price_level_id_value}
                      options={filteredPriceLevel}
                      onChange={(e) =>
                        handlePriceLevelChange(e, "price_level", key)
                      }
                      isDisabled={filteredPriceLevel.length > 0 ? false : true}
                    />
                  </Col>
                  <Col xs={4}></Col>
                  <Col xs={2} className="pt-3 PO-add-item">
                    <Button
                      type="button"
                      onClick={() => handleRemovePriceLevel(key)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                {data?.map((item, index) => {
                  return (
                    <>
                      <Row key={index} className="nc-modal-custom-row mt-3">
                        <Col className="unit">{item.unit_from}</Col>
                        <Col>
                          COST
                          <Form.Control
                            type="number"
                            name="cost_price"
                            value={item.cost_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            disabled={
                              parseFloat(item.original_cost_price) === 0
                                ? false
                                : true
                            }
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                          />
                        </Col>
                        <Col>
                          MARGIN %
                          <Form.Control
                            type="number"
                            name="margin"
                            value={item.margin}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SELLING PRICE
                          <Form.Control
                            type="number"
                            name="selling_price"
                            value={item.selling_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          WS PRICE
                          <Form.Control
                            type="number"
                            name="wholesale_price"
                            value={item.wholesale_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          RETAIL PRICE
                          <Form.Control
                            type="number"
                            name="retail_price"
                            value={item.retail_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                      </Row>
                      <Row key={index} className="nc-modal-custom-row mt-1">
                        <Col>
                          SPEC. PRICE 1
                          <Form.Control
                            type="number"
                            name="special_price_1"
                            value={item.special_price_1}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SPEC. PRICE 2
                          <Form.Control
                            type="number"
                            name="special_price_2"
                            value={item.special_price_2}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SPEC. PRICE 3
                          <Form.Control
                            type="number"
                            name="special_price_3"
                            value={item.special_price_3}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          VAT IN
                          <Form.Control
                            type="text"
                            name="vat_in"
                            value={
                              item.vat_in ? numberFormat(item.vat_in) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col>
                          VAT EX
                          <Form.Control
                            type="text"
                            name="vat_ex"
                            value={
                              item.vat_ex ? numberFormat(item.vat_ex) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col>
                          VAT COMPONENT
                          <Form.Control
                            type="text"
                            name="vat_component"
                            value={
                              item.vat_component
                                ? numberFormat(item.vat_component)
                                : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                      </Row>
                    </>
                  )
                })}
                <hr />
              </>
            )
          })}
          <Row className="pt-3 PO-add-item">
            <Button
              type="button"
              disabled={filteredPriceLevel.length > 0 ? false : true}
              onClick={() => handleAddPriceLevel()}
            >
              Add Price Level
            </Button>
          </Row>
        </div>
      </AddModal>
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
      <Footer />
    </div>
  )
}

FormPurchaseInvoice.defaultProps = {
  add: false,
  edit: false,
}

export default FormPurchaseInvoice
